import OtpInput from "react-otp-input";

const OtpInputComponent = ({ setOtp, otp, otpError}) => {
  const handleChange = (value) => {
    // Only keep numeric characters
    const numericValue = value.replace(/\D/g, "");
    setOtp(numericValue);
  };

  const handleKeyDown = (e) => {
    // Allow: Backspace, Tab, Arrow keys
    if (
      !/[0-9]/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Tab" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="flex justify-center">
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={6}
          renderSeparator={<span className="mx-2"></span>}
          renderInput={(props) => (
            <input
              {...props}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              onKeyDown={handleKeyDown} // <-- filter key presses
              className="!w-[58px] !h-[58px] border-[1px] border-[var(--Purple-100,#E7E7FF)] rounded-[5px] text-center text-2xl font-semibold text-gray-700 focus:outline-none focus:border-[var(--Action-Colors,#376AFA)] transition-all"
            />
          )}
        />
      </div>
      {otpError && (
        <p className="text-red text-size-10 font-regular mt-1">{otpError}</p>
      )}
    </>
  );
};

export default OtpInputComponent;
